import { Injectable } from '@angular/core';
import { CanMatch, Router, UrlTree } from '@angular/router';
import { AuthUtils } from 'app/core/auth/auth.utils';

/** Codename del permiso en auth_permission (content type `permisosfront`), en camelCase. */
export const PERMISO_EVIDENCIAS_CORREO = 'accesoEvidenciasCorreo';

/**
 * Deja entrar a "Evidencias de correo" solo a superuser o a quien tenga
 * acceso_evidencias_correo. Que sea interno (is_staff) lo valida el backend en cada ruta.
 */
@Injectable({ providedIn: 'root' })
export class EvidenciasCorreoGuard implements CanMatch {
    constructor(private readonly _router: Router) {}

    canMatch(): boolean | UrlTree {
        const permissionsToken = localStorage.getItem('permissionsToken');
        if (!permissionsToken) {
            return this._router.parseUrl('/sign-in');
        }
        try {
            if (AuthUtils._getTokenUser(permissionsToken)) {
                return true;
            }
            const permisos = AuthUtils._getTokenPermissionRol(permissionsToken) || [];
            return permisos.some((p) => this.normaliza(p) === PERMISO_EVIDENCIAS_CORREO)
                ? true
                : this._router.parseUrl('/home');
        } catch {
            return this._router.parseUrl('/home');
        }
    }

    /** Acepta el codename en snake_case o camelCase, igual que PermitService. */
    private normaliza(codename: string): string {
        return codename.replace(/_([a-z])/g, (_match, letra: string) => letra.toUpperCase());
    }
}
